import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import History from '@/js/plugins/CookieDb/History';
import { authCheck, zeroPadding, isPc } from '@/js/helpers';
import Favorite from '@/js/plugins/CookieDb/Favorite';
import SmoothScroll from 'smooth-scroll';
import GalleryModal from '@/js/plugins/GalleryModal';
import Modal from '@/js/plugins/Modal';

// サムネイルのもっと見る表示制御
const renderThumbnailAction = () => {
    let showAll = false;
    const thumbnailLength = $('.pg-gallery-thumbnails__item').not('[data-more]').length;
    if (isPc()) {
        if (thumbnailLength > 8) {
            showAll = true;
        }
    } else {
        if (thumbnailLength > 10) {
            showAll = true;
        }
    }
    if (showAll) {
        $('.pg-gallery-thumbnails__item[data-more]').on('click', (e) => {
            $('.pg-gallery-thumbnails__list').attr('data-render-no-limit', '');
        });
    }
}

// ギャラリーのアクション設定
const setGalleryAction = () => {
    renderThumbnailAction()

    // スライダーアクション
    $(".js-gallery-slider").slick({
        slidesToShow: 1,
        autoplay: true,
        speed: 400,
        autoplaySpeed: 3000,
        infinite: true,
    })

    // スライドのページ切り替え
    $('.pg-gallery-thumbnails__item').not('[data-more]').on('click', (e) => {
        const index = $(e.currentTarget).index()
        $(".js-gallery-slider").slick('slickGoTo', index)
    })
}

// 物件詳細の追加表示（SP）
const showPropertyDetail = () => {
    $('.pg-property-detail__more').on('click', (e) => {
        $('.pg-property-detail').addClass('is-open');
    })
}

const navAction = () => {
    const targetObj = document.querySelector('.pg-nav');

    const headerObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 領域内に入ったときの処理
                delete targetObj.dataset.fixed;
                targetObj.style.top = 0;
            } else {
                // 領域外に出たときの処理
                targetObj.dataset.fixed = '';
                targetObj.style.top = targetObj.clientHeight * -1 + 'px';
            }
        })
    });

    headerObserver.observe(document.querySelector('main > header'));

    let setPosition = 0;
    let scrollDirection = null;
    window.addEventListener('scroll', function () {
        if (setPosition < document.documentElement.scrollTop && scrollDirection !== 'down') {
            scrollDirection = 'down';
            delete targetObj.dataset.show;
        } else if (setPosition > document.documentElement.scrollTop && scrollDirection !== 'up') {
            scrollDirection = 'up';
            targetObj.dataset.show = '';
        }
        setPosition = document.documentElement.scrollTop;
    });
}

const setFavoriteAction = async (pageId) => {
    const targetObj = document.querySelector('.js-button-favorite');
    const favorite = new Favorite();
    const targetDb = authCheck() ? 'db' : 'cookie';
    const changeFavoriteState = (target, newState) => {
        if(newState){
            target.dataset.active = '';
        } else{
            delete target.dataset.active;
        }
        document.querySelectorAll('[data-favorite-count]').forEach((targetObj) => {
            const baseCount = targetObj.dataset.count ? Number(targetObj.dataset.count) : 0;
            const count = newState ? baseCount + 1 : baseCount - 1;
            targetObj.textContent = count < 99 ? count : '99+';
            targetObj.dataset.count = count;
        });
    }

    targetObj.addEventListener('click', async (e) => {
        const isFavorite = e.currentTarget.hasAttribute('data-active');
        changeFavoriteState(e.currentTarget, !isFavorite);

        const resp = await favorite.setState(targetDb, pageId, !isFavorite)
        if(!resp){
            changeFavoriteState(e.currentTarget, isFavorite);
        }
    })
}

const setOpenHouseAction = () => {
    if(document.querySelector('.pg-tour-body') === null) return;
    document.querySelector('.pg-tour-body__more').addEventListener('click', (e) => {
        document.querySelector('.pg-tour__body').dataset.open = '';
    });
    // コンテンツの縦サイズが親の高さを超えていたら「もっと見る」ボタンを表示
    const tourBody = document.querySelector('.pg-tour__body');
    console.log(tourBody.scrollHeight, tourBody.clientHeight)
    if(tourBody.scrollHeight > tourBody.clientHeight){
        document.querySelector('.pg-tour__body').dataset.more = '';
    }
}


const main = async () => {
    if (!document.querySelector('#page-property-detail')) return;
    const history = new History();
    const galleryModal = new GalleryModal({
        overlayClose: true,
        imgList: [...document.querySelectorAll('.pg-gallery__main-slider img')].map((img) => {
            return {
                src: img.src,
                alt: img.alt,
            }
        }),
    });
    const modal = new Modal;

    const pageId = document.querySelector('main').dataset.id;
    if (pageId.match(/^[0-9]+$/)) {
        // 閲覧履歴の記録
        history.setState(authCheck() ? 'db' : 'cookie', pageId, true)
    }

    // クリックした画像をモーダル表示
    document.querySelectorAll('.pg-gallery__main-slider img').forEach((img, index) => {
        img.addEventListener('click', (e) => {
            galleryModal.show(index)
        })
    });

    document.querySelectorAll('.pg-gallery-thumbnails__list img').forEach((img, index) => {
        img.addEventListener('click', (e) => {
            galleryModal.show(index)
        })
    });

    document.querySelectorAll('[data-modal-image]').forEach((obj) =>{
        obj.addEventListener('click', (e) => {
            const img = document.createElement('img');
            img.src = e.currentTarget.dataset.modalImage;
            const dom = document.createElement('div');
            dom.classList.add('img');
            dom.appendChild(img);
            modal.setDom(dom).show();
        });
    });

    // 戻るボタン
    $('.pg-fix-content__item--back a, .pg-back a').on('click', (e) => {
        e.preventDefault();
        window.history.back();
    });

    new SmoothScroll('a[href*="#"]', {
        speed: 300,
        header: '.l-header',
        speedAsDuration: true,
        easing: 'linear',
    });

    setOpenHouseAction()
    showPropertyDetail()
    setGalleryAction()
    navAction()
    setFavoriteAction(pageId)
}

export default main;
